
export function checkWord(solution, attempt) {
    const status = Array(solution.length).fill("absent");
    const solArray = solution.split("");

    // Première passe : exact
    attempt.split("").forEach((l, i) => {
      if (l === solArray[i]) {
        status[i] = "correct";
        solArray[i] = null;
      }
    });

    // Deuxième passe : présent
    attempt.split("").forEach((l, i) => {
      if (status[i] === "correct") return;
      if (status[i] === "present") return;
      const pos = solArray.indexOf(l);
      if (pos !== -1) {
        status[i] = "present";
        solArray[pos] = null;
      }
    });

    return status;
}

// clear data when game is over
export function clearStorage(userId) {
  localStorage.removeItem('motus_grid_'+userId);
  localStorage.removeItem('motus_statuses_'+userId);
  localStorage.removeItem('motus_confirmed_'+userId);
  localStorage.removeItem('motus_word_'+userId);
  localStorage.removeItem('motus_validate_'+userId);
  localStorage.removeItem('motus_keyboard_'+userId);
}